import React from 'react';
const coverage = [{
  label: 'Every practice',
  body: 'Two pages: Plan & Clock, then Run It. A 90-minute clock with the 60-minute cut marked'
}, {
  label: 'Every block',
  body: 'Warm-Up Game, Position of the Day, Drill Circuit, Situational Live, Conditioning Finisher, Huddle — in the same order every day'
}, {
  label: 'Two tracks',
  body: 'Track 1 Rookies and Track 2 Returners printed side by side, with short cues for each'
}, {
  label: 'Mixed rooms',
  body: 'Pairing rules, small-room and 30+ wrestler setups, easier and harder versions of every drill'
}, {
  label: 'Safety',
  body: "A Safety Cue on every higher-risk move. Follow your association's protocol and your athletic trainer"
}, {
  label: 'Format',
  body: 'Landscape PDFs that read on a phone at the edge of the mat or print for your clipboard'
}];
const steps = ['Open the practice', 'Pick your clock', 'Split into two tracks', 'Run it'];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-plum-mid" data-id="element-214" data-mp="1b0ftc50o7v2y">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-215" data-mp="1f0g6znfy428y">
        <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-216" data-mp="1jukhggof6ses">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-semibold text-white text-3xl sm:text-5xl" data-id="element-217" data-mp="1ougic71tm3q4">
          The Two-Track Practice System
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-218" data-mp="w3yfn750e4d8">
          A full season of practices, ordered from the first week of November to
          the state tournament. Every practice runs on two tracks at once, on
          the same blocks and the same clock:{' '}
          <span className="font-semibold text-white" data-id="element-219" data-mp="2chop6tewdku9">Track 1 Rookies</span> get
          the base version of the drill,{' '}
          <span className="font-semibold text-white" data-id="element-220" data-mp="2hiufkkl34w0m">Track 2 Returners</span>{' '}
          get the next progression of the same position. One room, two levels,
          one clock.
        </p>

        <ol className="mx-auto mt-8 flex max-w-3xl flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-221" data-mp="1mw5ehns9m5v0">
          {steps.map((step, i) => <li key={step} className="flex items-center gap-2 sm:gap-3" data-id="element-222" data-mp="1wrp63xzsqidy" data-mpi={i}>
              <span className="rounded-full bg-gold/15 px-4 py-2 text-[13px] font-semibold text-gold-hover" data-id="element-223" data-mp="1924nxhbgvp5q">
                <span className="mr-1.5 font-display" data-id="element-224" data-mp="143teh7p33go1">{i + 1}.</span>
                {step}
              </span>
              {i < steps.length - 1 && <span className="hidden h-px w-5 bg-gold/50 sm:block" data-id="element-225" data-mp="1iuafipxt44ke" />}
            </li>)}
        </ol>

        <ul className="mt-9 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-226" data-mp="qbmzhoxo3fq6">
          {coverage.map(item => <li key={item.label} className="rounded-xl border border-plum-line bg-white/5 px-4 py-3" data-id="element-227" data-mp="ldlhl7bz9mga">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-gold" data-id="element-228" data-mp="2wyua8qeb9yx5">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-229" data-mp="2n2r0ayd7wvzn">
                {item.body}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}